// Mirrors viz-core's vizTypeHelpers. Copy-pasted rather than imported to keep
// viz-core out of this bundle; keep the mappings in sync (canonical is REPORT).
export type VizType =
  | 'TABLE'
  | 'BOARD'
  | 'GANTT_CHART'
  | 'REPORT'
  // Legacy value in some persisted views; accepted as input, never emitted.
  | 'REPORTING'
  | 'MAP'
  | 'CALENDAR';

export type PageType =
  | 'list'
  | 'board'
  | 'gantt'
  | 'report'
  | 'map'
  | 'calendar';

/** Page type (or already-viz type) -> backend viz type enum. Idempotent. */
export function pageTypeToVizType(
  vizTypeOrPageType: VizType | PageType
): VizType {
  switch (vizTypeOrPageType) {
    case 'list':
      return 'TABLE';
    case 'board':
      return 'BOARD';
    case 'gantt':
      return 'GANTT_CHART';
    case 'report':
      return 'REPORT';
    case 'map':
      return 'MAP';
    case 'calendar':
      return 'CALENDAR';
    default:
      return vizTypeOrPageType.toUpperCase() as VizType;
  }
}

/** Backend viz type (or already-page type) -> internal page type. */
export function denormalizeVizType(
  vizTypeOrPageType: VizType | PageType
): PageType {
  switch (vizTypeOrPageType) {
    case 'TABLE':
      return 'list';
    case 'BOARD':
      return 'board';
    case 'GANTT_CHART':
      return 'gantt';
    case 'REPORTING':
    case 'REPORT':
      return 'report';
    case 'MAP':
      return 'map';
    case 'CALENDAR':
      return 'calendar';
    default:
      return vizTypeOrPageType as PageType;
  }
}
